module.exports = __webpack_public_path__ + "img/salon-confirm-bone.1b4377b0.svg";